// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Product_wrap__mFB1G","inner":"Product_inner__GFxSh"};